import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { raisePostRequest } from "../AxiosAPI";
import { CrackersContext } from "../CrackersContext";
import { Button, Col, Row } from "react-bootstrap";
import BreadcrumbMenu from "./BreadcrumbMenu";

function OrderDetails({}) {

    const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage } = useContext(CrackersContext);
    const [order, setOrder] = useState({});
    const [orderExist, setOrderExist] = useState(false);
    const { orderId } = useParams();

    useEffect(() => {
        const orderDetails = async () => {
            const response = await raisePostRequest(`/orders/${orderId}`, null, null, setShowErrorToastStatus, setToastBody);
            if(response) {
                setOrder(response);
                setIsZeroCasePage(false);
                setOrderExist(true);
            } else {
                setOrderExist(false);
            }
        }
        orderDetails();
    }, [])

    const paymentStatus = () => {
        switch(order.payment_status) {
            default:
            case 0:
                return (<><span style={{color : "red"}}>Unpaid</span></>);
            case 1:
                return (<><span style={{color : "orange"}}>Waiting for payment Approval</span></>);
            case 2:
                return (<><span style={{color : "green"}}>Paid</span></>);
        }
    }

    const paymentId = () => {
        if(order.payment_id) {
            return order.payment_id;
        } else {
            return "NA";
        }
    }

    const paymentConfirmation = () => {
        if(order.payment_confirmation_time) {
            return (<><span style={{color : "green"}}>Confirmed</span></>);
            // return dateTimeConverter(order.payment_confirmation_time);
        } else {
            return (<><span style={{color : "red"}}>Not Confirmed</span></>);
        }
    }

    const dispatchStatus = () => {
        switch(order.dispatch_status) {
            default:
            case 0:
                return (<><span>Waiting for payment/confirmation</span></>);
            case 1:
                return (<><span style={{color : "orange"}}>Approved and Queued</span></>);
            case 2:
                return (<><span style={{color : "orange"}}>Prepared</span></>);
            case 3:
                return (<><span style={{color : "orange"}}>Dispatched</span></>);
            case 4:
                return (<><span style={{color : "green"}}>In transist</span></>);
            case 5:
                return (<><span style={{color : "green"}}>Arrived destination</span></>);
        }
    }

    const dispatchSlip = () => {
        if(order.dispatch_status < 4) {
            // var dispatchSlipLink = `/v1/orders/${order.id}/dispatch_ss`;
            // return (<><a href={dispatchSlipLink}>Click here to download</a></>);
            return "NA";
        } else {
            var dispatchSlipLink = `/v1/orders/${order.id}/dispatch-ss`;
            return (<><a href={dispatchSlipLink}>Click here to download</a></>);
        }
    }

    return(
        (orderExist) ? (
            <div className="odr_dtl_cnt">
                <Row style={{ position: "sticky", top: "11%", zIndex: "1", marginBottom: "1%" }}>
                    <Col xs={1}></Col>
                    <Col xs={11}>
                        <BreadcrumbMenu items={[
                            { caption: "Home", link: "/web" },
                            { caption: "Orders", link: "/web/orders"},
                            { caption: order.id, activePage: true }
                        ]} />
                    </Col>
                </Row>
                <Row>
                    <Col md={1}></Col>
                    <Col md={5}>
                        <div class="card">
                            <div class="section-title">Order Details</div>
                            <div class="info"><span>Order ID:</span> {order.id}</div>
                            <div class="info"><span>Total Amount:</span> ₹{order.order_price}</div>
                            <div class="info"><span>Payment Status:</span> <span class="status">{paymentStatus()}</span></div>
                            <div class="info"><span>Dispatch Status:</span> {dispatchStatus()}</div>
                            <div class="info"><span>Pickup Location:</span> {order.order_to}</div>
                        </div>
                    </Col>
                    <Col md={5} hidden={order.payment_status === 2}>
                        <div class="card qr-section">
                            <div class="section-title">Scan & Pay</div>
                            <img src={`/v1/orders/${order.id}/payment-qrcode?size=300`} style={{width : '30%', height : '30%'}}></img>
                            {/* <img src="/mnt/data/0e6f3a45-cd31-4f2a-a5fb-aecc8cc3bca0.png" alt="QR Code"> */}
                            <a href={order.payment_link} class="btn"><Button>Pay Now</Button></a>
                            <p style={{fontWeight : "bold"}}>Scan this QR with UPI App or tap the button above to complete your payment securely.</p>
                        </div>
                    </Col>
                </Row>
                <div class="container">
                    
                    
                </div>

                
            </div>
        ) : (
            <div className="ct-vw">
                <div className="center_of_scrn_empt_ct">
                    <h1>No orders found in your account.</h1>
                    <h5>Explore our <a href="/web/crackers">crackers</a> and place an order.</h5>
                </div>
            </div>
        )
    );
}

export default OrderDetails;